import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities, loading }) => {
  const getActivityIcon = (action) => {
    switch (action) {
      case 'login':
        return 'LogIn';
      case 'logout':
        return 'LogOut';
      case 'role_change':
        return 'Shield';
      case 'permission_change':
        return 'Key';
      case 'user_create':
        return 'UserPlus';
      case 'user_update':
        return 'Edit';
      case 'user_delete':
        return 'UserMinus';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (action) => {
    switch (action) {
      case 'login':
        return 'text-success bg-success/10';
      case 'logout':
        return 'text-muted-foreground bg-muted';
      case 'role_change': case'permission_change':
        return 'text-warning bg-warning/10';
      case 'user_create':
        return 'text-primary bg-primary/10';
      case 'user_delete':
        return 'text-error bg-error/10';
      default:
        return 'text-foreground bg-muted';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const formatActionText = (action) => {
    return action?.split('_')?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Recent Activity</h3>
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <Icon name="Activity" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities && activities?.length > 0 ? (
          activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start gap-3 pb-4 border-b border-border last:border-0 last:pb-0">
              <div className={`flex-shrink-0 p-2 rounded-lg ${getActivityColor(activity?.action)}`}>
                <Icon name={getActivityIcon(activity?.action)} size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">
                  {formatActionText(activity?.action)}
                </p>
                <p className="text-xs text-muted-foreground mt-1 truncate">
                  {activity?.userProfiles?.fullName || 'System'} - {activity?.details || 'No details'}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  {formatTimestamp(activity?.timestamp)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="Inbox" size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">No recent activity</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;